// Helpers
import { addDate } from 'src/helpers/date_helper';
import { sortOn } from 'src/helpers/utilities';
import { CHART_VARIANTS_LIST } from '../ui/chart_menu_actions_helpers';
import { TEMP_SCHEME_CHART_HEIGHT } from './chart_config';
//Types
import type { ChartDataInterface } from 'src/types/Chart';
import type { IChartTempSchedule } from 'src/types/TemperatureSchemeType';

export const getTRVSchemeChartConfig = (
	range: number,
	tempSchedule: IChartTempSchedule,
	startWeekOnSun = false,
): ChartDataInterface => {
	return getTempSchemeChartConfig(range, tempSchedule, startWeekOnSun, true);
};

export const getTempSchemeChartConfig = (
	range: number,
	tempSchedule: IChartTempSchedule,
	startWeekOnSun = false,
	TRVScheme = false,
): ChartDataInterface => {
	const startDate = Date.UTC(2023, 0, 1, 0, 0, 0, 0),
		data = [],
		sunday = [],
		addDataset = (dt: number, value: number, i: number) => {
			const dateset = { dt, value, day: i };
			i == 0 ? sunday.push(dateset) : data.push(dateset);
		};
	let intervals = [];
	for (let i = 0; i < tempSchedule.intervals.length; ++i) {
		const interval = tempSchedule.intervals[i],
			splitTime = interval.time[0].split(':'),
			days = interval.days;
		for (let j = 0; j < days.length; ++j) {
			let day = days[j];
			if (TRVScheme) {
				day += 1;
				if (day == 7) day = 0;
			}
			const hour = Number(splitTime[0]),
				min = Number(splitTime[1]);
			let time = addDate(startDate, 'h', day * 24 + hour);
			time = addDate(time, 'i', min);
			intervals.push({
				time: time.getTime(),
				day,
				hour,
				min,
				value: interval?.disabled ? null : interval.base,
			});
			if (!TRVScheme) {
				const splitTimeТо = interval.time[1].split(':'),
					hourTo = Number(splitTimeТо[0]),
					minTo = Number(splitTimeТо[1]);
				let dayTo = day,
					timeTo = addDate(startDate, 'h', day * 24 + hourTo);
				timeTo = addDate(timeTo, 'i', minTo);
				if (timeTo.getTime() <= time.getTime()) {
					timeTo = addDate(timeTo, 'd', 1);
					dayTo = timeTo.getDay();
					if (dayTo == 0) {
						timeTo = addDate(timeTo, 'w', -1);
					}
				}
				intervals.push({
					time: timeTo.getTime(),
					day: dayTo,
					hour: hourTo,
					min: minTo,
					base: true,
					value: tempSchedule.base,
				});
			}
		}
	}
	intervals = sortOn(intervals, 'time');
	if (!TRVScheme) {
		const baseIntervals = intervals.filter((v) => v.base);
		for (let i = 0; i < baseIntervals.length; ++i) {
			if (intervals.find((v) => !v.base && v.time == baseIntervals[i].time)) {
				intervals = intervals.filter((v) => v != baseIntervals[i]);
			}
		}
	}
	let value = intervals.length > 0 ? intervals[intervals.length - 1].value : tempSchedule.base;
	for (let i = 0; i < 7; ++i) {
		const date = i > 0 ? addDate(startDate, 'd', i) : startDate;
		for (let j = 0; j < 24; ++j) {
			let dt = addDate(date, 'h', j).getTime();
			const interval = intervals.filter((v) => v.day == i && v.hour == j);
			if (interval.length) {
				if (!interval.find((v) => v.min == 0)) {
					addDataset(dt, value, i);
				}
				for (let int = 0; int < interval.length; ++int) {
					if (value != null && interval[int].value == null) {
						addDataset(addDate(dt, 'i', interval[int].min).getTime(), value, i);
					}
					value = interval[int].value;
					if (interval[int].min != 0) {
						addDataset(addDate(dt, 'i', interval[int].min).getTime(), value, i);
					} else {
						addDataset(dt, value, i);
					}
				}
			} else {
				addDataset(dt, value, i);
			}
		}
	}
	let seriesData = startWeekOnSun ? [...sunday, ...data] : [...data, ...sunday];
	if (range >= 0) seriesData = seriesData.filter((i) => i.day == range);
	return {
		name: 'tempSchedule',
		type: CHART_VARIANTS_LIST[3],
		units: '°' + (tempSchedule.units || 'C'),
		rangePeriod: range == -1 ? 'week' : 'day',
		series: [
			{
				name: 'tempSchedule',
				data: seriesData,
				visible: true,
				style: `tempSchedule_${tempSchedule.type}`,
			},
		],
		height: TEMP_SCHEME_CHART_HEIGHT,
		disabled: !TRVScheme && !tempSchedule._enabled,
	};
};
